// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyD0aE4mECVFwmiqJr-2vHcoZhbSF8jCD9k',
  authDomain: 'l-autre-part-85.firebaseapp.com',
  projectId: 'l-autre-part-85',
  storageBucket: 'l-autre-part-85.firebasestorage.app',
  messagingSenderId: '796002110403',
  appId: '1:796002110403:web:b15805d15a30152a8f8b76',
  measurementId: 'G-1J0R1EJ3S8',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app, 'l-autre-part');
export const storage = getStorage(app);
export const analytics = getAnalytics(app);
